module.exports = __webpack_public_path__ + "fonts/Lato-Medium.0996d39.woff2";